import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../assets/basketPlayScore.jpg'


const _hoisted_1 = { class: "play_score" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "banner_img_cba" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"margin":"0px 0px 0px 0px"},
    alt: ""
  })
], -1)
const _hoisted_3 = {
  class: "play_score_title",
  style: {"color":"floralwhite"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("积分榜 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("胜负")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("名次")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "custom-text" }, "A组", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "场次", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "胜", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "负", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "积分", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "名次", -1)
const _hoisted_13 = { class: "index_style" }
const _hoisted_14 = { class: "item_name" }
const _hoisted_15 = { class: "index_style" }
const _hoisted_16 = { class: "index_style" }
const _hoisted_17 = { class: "index_style" }
const _hoisted_18 = { class: "index_style" }
const _hoisted_19 = { class: "index_style" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "custom-text" }, "B组", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "场次", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "胜", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "负", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "积分", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "名次", -1)
const _hoisted_26 = { class: "index_style" }
const _hoisted_27 = { class: "item_name" }
const _hoisted_28 = { class: "index_style" }
const _hoisted_29 = { class: "index_style" }
const _hoisted_30 = { class: "index_style" }
const _hoisted_31 = { class: "index_style" }
const _hoisted_32 = { class: "index_style" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "custom-text" }, "C组", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "场次", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "胜", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "负", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "积分", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "名次", -1)
const _hoisted_39 = { class: "index_style" }
const _hoisted_40 = { class: "item_name" }
const _hoisted_41 = { class: "index_style" }
const _hoisted_42 = { class: "index_style" }
const _hoisted_43 = { class: "index_style" }
const _hoisted_44 = { class: "index_style" }
const _hoisted_45 = { class: "index_style" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "custom-text" }, "D组", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, "场次", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", null, "胜", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, "负", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", null, "积分", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", null, "名次", -1)
const _hoisted_52 = { class: "index_style" }
const _hoisted_53 = { class: "item_name" }
const _hoisted_54 = { class: "index_style" }
const _hoisted_55 = { class: "index_style" }
const _hoisted_56 = { class: "index_style" }
const _hoisted_57 = { class: "index_style" }
const _hoisted_58 = { class: "index_style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_stepper = _resolveComponent("van-stepper")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("div", {
        class: "rank_add_winlose",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addScoreWinLose && _ctx.addScoreWinLose(...args)))
      }, [
        _hoisted_5,
        _createVNode(_component_van_icon, {
          name: "add-o",
          size: "30px"
        })
      ], 512), [
        [_vShow, _ctx.memberId == 546 || _ctx.memberId == 6]
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "rank_add_getlose",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addScoreGetLose && _ctx.addScoreGetLose(...args)))
      }, [
        _hoisted_6,
        _createVNode(_component_van_icon, {
          name: "add-o",
          size: "30px"
        })
      ], 512), [
        [_vShow, _ctx.memberId == 546 || _ctx.memberId == 6]
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_van_grid, {
        direction: "horizontal",
        "column-num": 11,
        border: false,
        class: "grid_style_a"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_grid_item, { class: "group_column" }, {
            text: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_list, {
      class: "van-list-container_a",
      loading: _ctx.loading,
      "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
      offset: "10",
      finished: _ctx.finished,
      "finished-text": "",
      onLoad: _ctx.onLoad
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aTeamScoreList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: _normalizeClass(index%2==0 ? 'first_color' : 'second_color')
          }, [
            (item.by2=='A')
              ? (_openBlock(), _createBlock(_component_van_grid, {
                  key: 0,
                  "column-num": 11,
                  direction: "horizontal",
                  border: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(index+1), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "wide-column" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_icon, {
                          name: item.avatar,
                          size: "4vh",
                          class: "item_avatar"
                        }, null, 8, ["name"]),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(item.session), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(item.win), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(item.fail), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(item.score), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(item.teamRank), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"]),
    _createElementVNode("div", null, [
      _createVNode(_component_van_grid, {
        direction: "horizontal",
        "column-num": 11,
        border: false,
        class: "grid_style_b"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_grid_item, { class: "group_column" }, {
            text: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_list, {
      class: "van-list-container_b",
      loading: _ctx.loading,
      "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loading) = $event)),
      offset: "10",
      finished: _ctx.finished,
      "finished-text": "",
      onLoad: _ctx.onLoad
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bTeamScoreList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: _normalizeClass(index%2==0 ? 'first_color' : 'second_color')
          }, [
            (item.by2=='B')
              ? (_openBlock(), _createBlock(_component_van_grid, {
                  key: 0,
                  "column-num": 11,
                  direction: "horizontal",
                  border: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(index+1), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "wide-column" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_icon, {
                          name: item.avatar,
                          size: "4vh",
                          class: "item_avatar"
                        }, null, 8, ["name"]),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(item.session), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_29, _toDisplayString(item.win), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(item.fail), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_31, _toDisplayString(item.score), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(item.teamRank), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"]),
    _createElementVNode("div", null, [
      _createVNode(_component_van_grid, {
        direction: "horizontal",
        "column-num": 11,
        border: false,
        class: "grid_style_c"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_grid_item, { class: "group_column" }, {
            text: _withCtx(() => [
              _hoisted_33
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_34
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_35
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_36
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_37
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_38
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_list, {
      class: "van-list-container_c",
      loading: _ctx.loading,
      "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loading) = $event)),
      offset: "10",
      finished: _ctx.finished,
      "finished-text": "",
      onLoad: _ctx.onLoad
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cTeamScoreList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: _normalizeClass(index%2==0 ? 'first_color' : 'second_color')
          }, [
            (item.by2=='C')
              ? (_openBlock(), _createBlock(_component_van_grid, {
                  key: 0,
                  "column-num": 11,
                  direction: "horizontal",
                  border: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_39, _toDisplayString(index+1), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "wide-column" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_icon, {
                          name: item.avatar,
                          size: "4vh",
                          class: "item_avatar"
                        }, null, 8, ["name"]),
                        _createElementVNode("span", _hoisted_40, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_41, _toDisplayString(item.session), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(item.win), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_43, _toDisplayString(item.fail), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_44, _toDisplayString(item.score), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_45, _toDisplayString(item.teamRank), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"]),
    _createElementVNode("div", null, [
      _createVNode(_component_van_grid, {
        direction: "horizontal",
        "column-num": 11,
        border: false,
        class: "grid_style_d"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_grid_item, { class: "group_column" }, {
            text: _withCtx(() => [
              _hoisted_46
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_47
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_48
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_49
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_50
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "common‌-column" }, {
            default: _withCtx(() => [
              _hoisted_51
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_list, {
      class: "van-list-container_d",
      loading: _ctx.loading,
      "onUpdate:loading": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.loading) = $event)),
      offset: "10",
      finished: _ctx.finished,
      "finished-text": "",
      onLoad: _ctx.onLoad
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dTeamScoreList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: _normalizeClass(index%2==0 ? 'first_color' : 'second_color')
          }, [
            (item.by2=='D')
              ? (_openBlock(), _createBlock(_component_van_grid, {
                  key: 0,
                  "column-num": 11,
                  direction: "horizontal",
                  border: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_52, _toDisplayString(index+1), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "wide-column" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_icon, {
                          name: item.avatar,
                          size: "4vh",
                          class: "item_avatar"
                        }, null, 8, ["name"]),
                        _createElementVNode("span", _hoisted_53, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_54, _toDisplayString(item.session), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_55, _toDisplayString(item.win), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_56, _toDisplayString(item.fail), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_57, _toDisplayString(item.score), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_grid_item, { class: "team_score" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_58, _toDisplayString(item.teamRank), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"]),
    _createVNode(_component_van_popup, {
      show: _ctx.winShow,
      position: "bottom",
      style: _normalizeStyle([{"height":"90%"}, {bottom:'0vh'}]),
      closeable: "",
      onClickCloseIcon: _cache[6] || (_cache[6] = ($event: any) => (_ctx.winShow = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_grid, {
          direction: "horizontal",
          "column-num": 4,
          style: {"padding-top":"4vh"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_grid_item, { text: "球队" }),
            _createVNode(_component_van_grid_item, { text: "胜" }),
            _createVNode(_component_van_grid_item, { text: "负" }),
            _createVNode(_component_van_grid_item, { text: "操作" })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamScoreList, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_grid, {
            "column-num": 4,
            key: item,
            class: _normalizeClass(index<4 ? 'first_color' : index<8 ? 'second_color': index<12 ? 'first_color':'second_color')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_grid_item, {
                text: item.rankName
              }, null, 8, ["text"]),
              _createVNode(_component_van_stepper, {
                modelValue: item.win,
                "onUpdate:modelValue": ($event: any) => ((item.win) = $event),
                min: 0,
                step: "1",
                "disable-input": "",
                "input-width": "40px",
                "button-size": "25px",
                class: "wide-getcolumn"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_van_stepper, {
                modelValue: item.fail,
                "onUpdate:modelValue": ($event: any) => ((item.fail) = $event),
                min: 0,
                step: "1",
                "disable-input": "",
                "input-width": "40px",
                "button-size": "25px",
                class: "wide-getcolumn"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_van_grid_item, {
                text: "确认",
                onClick: ($event: any) => (_ctx.submitTeamScore(item))
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.getShow,
      position: "bottom",
      style: _normalizeStyle([{"height":"90%"}, {bottom:'0vh'}]),
      closeable: "",
      onClickCloseIcon: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getShow = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_grid, {
          direction: "horizontal",
          "column-num": 3,
          style: {"padding-top":"4vh"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_grid_item, { text: "球队" }),
            _createVNode(_component_van_grid_item, {
              text: "名次",
              class: "wide-column"
            }),
            _createVNode(_component_van_grid_item, { text: "操作" })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamScoreList, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_grid, {
            "column-num": 4,
            key: item,
            class: _normalizeClass(index<4 ? 'first_color' : index<8 ? 'second_color': index<12 ? 'first_color':'second_color')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_grid_item, {
                text: item.rankName
              }, null, 8, ["text"]),
              _createVNode(_component_van_stepper, {
                modelValue: item.teamRank,
                "onUpdate:modelValue": ($event: any) => ((item.teamRank) = $event),
                min: 0,
                step: "1",
                "disable-input": "",
                "input-width": "40px",
                "button-size": "25px",
                class: "wide-getcolumn"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_van_grid_item, {
                text: "确认",
                onClick: ($event: any) => (_ctx.submitTeamGetLose(item))
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}